<template>
  <v-card
    outlined
    class="backoffice-table"
    style="box-shadow: none !important;"
  >
    <v-data-table
      :headers="headers"
      :items="items"
      :search="search"
      :page.sync="page"
      :items-per-page="itemsPerPage"
      :server-items-length="totalItems"
      hide-default-footer
      @page-count="pageCount = $event"
      class="elevation-1"
      :loading="loading"
      :mobile-breakpoint="0"
    >
      <template v-slot:top>
        <v-toolbar flat color="transparent">
          <v-spacer></v-spacer>
          <v-text-field
            class="search-feild"
            v-model="search"
            append-icon="mdi-magnify"
            placeholder="Pesquisar por"
            dense
            solo
            flat
            filled
            hide-details
            clearable
            @keydown.enter="getItems(0, itemsPerPage)"
          ></v-text-field>
          <!-- Create/Edit Dialog -->
          <v-dialog
            v-model="dialog"
            max-width="600px"
            content-class="backoffice-dialog"
            scrollable
          >
            <!-- Dialog Button -->
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                depressed
                color="primary"
                height="40"
                v-bind="attrs"
                v-on="on"
                @click="
                  editedItem = Object.assign({}, emptyItem);
                  dialogTitle = 'Adicionar noticia';
                "
                >Adicionar noticia</v-btn
              >
            </template>
            <v-card>
              <!-- Close X button -->
              <v-toolbar flat color="#EBEFF3">
                <v-btn
                  icon
                  @click="dialog = false"
                  class="close-btn"
                  color="#9AABB8"
                  height="40"
                  width="40"
                >
                  <v-icon small>mdi-close</v-icon>
                </v-btn>
              </v-toolbar>
              <!-- Input text fields -->
              <v-row style="overflow-y: auto;">
                <v-col cols="12" class="dialog-frame">
                  <div class="dialog-title">{{ dialogTitle }}</div>
                  <v-row>
                    <v-col>
                      <div class="dialog-label">Titulo</div>
                      <v-text-field
                        class="dialog-text"
                        dense
                        filled
                        hide-details
                        v-model="editedItem.title"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col>
                      <div class="dialog-label">Descrição</div>
                      <v-textarea
                        class="dialog-text"
                        dense
                        filled
                        hide-details
                        v-model="editedItem.description"
                      ></v-textarea>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col>
                      <div class="dialog-label">Imagem</div>
                      <v-text-field
                        class="dialog-text"
                        dense
                        filled
                        hide-details
                        v-model="editedItem.image"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col>
                      <div class="dialog-label">Nome da fonte</div>
                      <v-text-field
                        class="dialog-text"
                        dense
                        filled
                        hide-details
                        v-model="editedItem.source"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col>
                      <div class="dialog-label">Link da fonte</div>
                      <v-text-field
                        class="dialog-text"
                        dense
                        filled
                        hide-details
                        v-model="editedItem.link"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
              <!-- Card Actions / Footer button -->
              <v-card-actions>
                <v-btn
                  color="primary"
                  block
                  tile
                  depressed
                  @click="addItem()"
                  :loading="loading"
                  >Submeter</v-btn
                >
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-toolbar>
      </template>
      <!-- Image Template -->
      <template v-slot:[`item.date`]="{ item }">
        {{ $moment(item.date, "x").format("HH[h]mm . D MMM YYYY")}}
      </template>
      <!-- Actions Template -->
      <template v-slot:[`item.actions`]="{ item }">
        <v-btn
          depressed
          dark
          color="#D8E0E6"
          class="gray-button"
          @click="editItem(item)"
          style="margin-right: 8px;"
          >Editar</v-btn
        >
        <RemoveItem
          :target="'noticia'"
          @remove-item="deleteItem(item)"
        ></RemoveItem>
      </template>
      <template v-slot:[`body.append`]="{ headers }">
        <tr v-for="n in itemsPerPage - items.length" :key="'tr-' + n">
          <td :colspan="headers.length"></td>
        </tr>
      </template>
    </v-data-table>
    <div class="pagination">
      <v-pagination v-model="page" :length="pageCount"></v-pagination>
    </div>
  </v-card>
</template>

<style scoped>
.backoffice-table >>> tr td:nth-child(1) {
  max-width: 200px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.pagination >>> .v-application .primary {
    background-color: red !important;
}
@media only screen and (max-width: 1024px) {
  .backoffice-table >>> .v-data-table__wrapper {
    overflow: auto;
  }
  .backoffice-table >>> table {
    width: 1180px;
  }
}
</style>

<script>
import Vue from "vue";

import RemoveItem from "@/components/RemoveItem";
import ApiService from "@/services/api.service";

export default Vue.extend({
  name: "NewsTable",
  components: {
    RemoveItem
  },
  props: { data: {} },
  data: () => ({
    dialog: false,
    loading: false,
    page: 1,
    pageCount: 0,
    itemsPerPage: 10,
    search: "",
    headers: [
      { text: "Título", value: "title", sortable: false },
      { text: "Fonte", value: "source", sortable: false },
      { text: "Data", value: "date", sortable: false },
      { text: "", align: "end", value: "actions", sortable: false }
    ],
    items: [],
    totalItems: 0,
    dialogTitle: "",
    editedItem: {
      id: "",
      title: "",
      description: "",
      image: "",
      source: "",
      link: ""
    },
    emptyItem: {
      id: "",
      title: "",
      description: "",
      image: "",
      source: "",
      link: ""
    }
  }),
  created() {
    this.getItems(0, this.itemsPerPage);
  },
  methods: {
    getItems(page, size) {
      this.loading = true;
      ApiService.getNews(this.search, page, size).then(
        response => {
          this.items = response.data.news;
          this.totalItems = response.data.totalElements;
          this.loading = false;
        },
        error => {
          console.log(
            (error.response && error.response.data) ||
              error.message ||
              error.toString()
          );
        }
      );
    },
    editItem(item) {
      this.dialogTitle = "Editar modalidade";
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },
    deleteItem(item) {
      this.loading = true;
      ApiService.deleteNews(item.id).then(
        response => {
          console.log(response.data);
          this.loading = false;
          this.getItems(this.page - 1, this.itemsPerPage);
        },
        error => {
          console.log(
            (error.response && error.response.data) ||
              error.message ||
              error.toString()
          );
        }
      );
    },
    addItem() {
      this.loading = true;
      ApiService.saveNews(this.editedItem).then(
        response => {
          this.dialog = false;
          this.loading = false;
          this.getItems(this.page - 1, this.itemsPerPage);
        },
        error => {
          console.log(
            (error.response && error.response.data) ||
              error.message ||
              error.toString()
          );
        }
      );
    }
  }
});
</script>